import { create } from "domain";

export const globalVariables = {
  noRecords: "No records found for this trial.",
  EmptyList: "No data available!",
  ErrorMessage: "Something went wrong",
  LoaderMessage: "Your request is being processed",
  createYourAccount: "Create Your Account",
  createAccount: "Create Account",
  startedEnterDetails: "Let’s get started! Please enter your details.",
  name: "Name",
  enterName: "Enter your name",
  email: "Email",
  enterEmail: "Enter your email",
  password: "Password",
  newPassword: "New Password",
  mustHaveAtlease:
    'Password must be at least 8 characters long and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character from the OWASP standard set: space ! " # $ % & \' ( ) * + , - . / : ; < = > ? @ [ \\ ] ^ _ ` { | } ~',
  createDate: "Created Date",
  updatedDate: "Updated Date",
  confirmPassword: "Confirm New Password",
  confirmPasswordSignUp: "Confirm Password",
  tempPassword: "••••••••",
  alreadyMember: "Already a member?",
  logIn: "Log in",
  sessionExpire: "Your session is expired",
  byCreatingAnAccount: "By creating an account, you agree to our",
  termsConditions: "Terms & Conditions",
  and: "and",
  privacyPolicy: "Privacy Policy",
  emailRequired: "Please enter a valid email address.",
  invalidEmail: "Please enter a valid email address.",
  passwordRequired: "Password is required",
  nameRequired: "Name is required",
  passwordNotMatch: "Passwords does not match",
  welcome: "Welcome",
  welcomeBack: "Welcome back! Please enter your details.",
  everythingYouNeed: "Everything you need is right here. Let’s get started!",
  forgotPassword: "Forgot Password / Change Password",
  dontHaveAccount: "Don’t have an account yet?",
  signUp: "Sign up",
  resetLink: "Send OTP Code",
  rememberPassword: "Remember your password?",
  sendResetLink:
    "If you have an account with us, a OTP code will be sent to your registered email address.",
  // newPassword: "New Password",
  resetPassword: "Reset Password",
  enterNewPassword: "Enter a new password.",
  restPasswordSuccess: "Password reset successful!",
  restPasswordDescription: "Your password has been reset.",
  restPasswordPending: "Password Reset failed",

  // Register Member

  registerMember: "Register Member",
  registerDog: "Register Your Dog",
  dogDetails: "Dog Details",
  dogStatus: "Dog Status",
  memberDetai: "Member Detail",
  memberDetails: "Member Details",
  memberSince :"Member Since",
  userDetails: "Member Details",
  switchRole: "Switch Roles",
  roleSwitchPermissionError: "You don't have a permission for this role",
  makePayment: "Make Payment",
  makePaymentForPendingDesc:
    "To start participating in trials, click below to make a payment.",
  addMemberDetails: "Add Member Details",
  thereRegistrationFee: "There is no registration fee for member",
  clickToUpload: "Click to upload",
  dragAndDrop: "or drag and drop",
  svgPNG: "PNG, JPG (max. 800x400px)",
  enterFirstName: "Enter first name",
  enterLastName: "Enter last name",
  enterEmailAddress: "Enter email address",
  enterLocationAddress: "Enter Location Address",
  enterPhoneNumber: "Enter phone number",
  enterEmergencyContactName: "Enter emergency contact name",
  enterEmergencyPhoneNumber: "Enter Emergency Phone Number",
  emergencyContactNumber:"Emergency Contact Number",
  cityHelperText: "If your city isn't listed in the dropdown - type it in.",
  cancel: "Cancel",
  next: "Next",
  firstNameRequired: "Please enter your first name to proceed.",
  lastNameRequired: "Please enter your last name to proceed.",
  locationRequired: "Please enter a valid location address.",
  invalidPhoneNumber: "Please enter a valid phone number.",
  phoneRequired: "Please enter a valid phone number.",
  contactNameRequired: "Please enter a valid emergency contact name.",
  contactNumberRequired: "Please enter a valid emergency contact number.",
  // Register Dog

  addDogDetails: "Add Dog Details ",
  oneTimeRegistration:
    "There is a one-time fee of $40 to register your dog. Once your dog is registered and their status is “Active”, they are eligible to participate in KSG trials.",
  addDog: "Add dog",
  addAnotherDog: "Add another dog",
  Skip: "Skip",
  payLater: "Pay Later?",
  enterCallName: "Dog Name",
  enterRegistrationName: "Registration Name",
  enterRegisteredName: "Registered Name",
  dateOfBirth: "Date of Birth",
  breedMix: "Breed Mix",
  specifyBreed: "Specify Breed",
  gender: "Gender",
  rescue: "Rescue",
  yes: "Yes",
  no: "No",
  back: "Back",
  callNameRequired: "Dog name is required",
  registrationNameRequired: "Registration name is required",
  breedMixRequired: "Breed mix is required",
  save: "Save",
  sureSkip: "Are you sure you want to skip registration of your dog?",
  registeringDogParticipate:
    "By registering your dog, your dog can participate in trials.",

  registerDogRequired: "Registration of your dog required",
  registerDogSubText: "To add another dog, please register your dog first.",

  pleaseSelectDate: "Please select Date",
  uploadedImageNotValid: "Uploaded image is not valid",
  uploadedFileNotValid: "Uploaded file is not valid",
  maximumFileSizeAllowed: "Maximum file size allowed is 5MB.",
  selectBreed: "Please select a Breed from the drop-down.",
  selectGender: "Please select a gender from the drop-down.",
  // Dashboard

  enterOTPCode: "Enter OTP code",
  sentOTPInMail: "This code has been sent to your registered email ID",
  OTP: "OTP Code",
  sendOTPCode: "Continue",
  notReceiveCode: "Didn’t receive code?",
  resendCode: "Resend Code",
  otpCodeSuccess: "OTP code sent successfully!",
  forgetOTPDesc: "Please set a new password to continue",
  otpSuccessDescription: "Please check your registered email ID for the code.",
  forgetEmailSuccess: "Email Send successfully!",

  // Dashboard
  myDogs: "My Dogs",
  myDashboard: "My Dashboard",
  joinOurCommunity: "Join Our Community",
  submitInfoMessage: "Submit the form for more information",
  joinCommunityText: "Whether you're interested in becoming a judge or hosting a trial, we’d love for you to join our community. Our team will guide you every step of the way. Ready to make an impact?",
  myTrial: "My Trials",
  memberDashboard: "Member Dashboard",
  trialCalendar: "Trial Calendar",
  trialResults: "Trial Results",
  trialResultsNAE: "Trial Results - NA&E",
  dogHistory: "Dog History",
  contactDetails: "Contact Details",
  emergencyContact: "Emergency Contact",
  registerYourDog: "Register Your Dog",
  registeringDog:
    `There is a one-time fee of $40 to register your dog. Once the fee is paid, your dog will be marked "Active" and will be eligible to participate in KSG trials.`,
  register: "Register",
  breed: "Breed",
  dogBreed: "Dog Breed",
  sex: "Gender",
  dob: "DOB",
  status: "Status",
  dogs: "Dogs",
  participantDogs: "Participant Dogs",
  search: "Search",
  selectTitle: "Select Title",
  signUpSuccessful: "Sign Up Successful!",
  signUpSuccessfulDesc:
    "Verify your email to complete registration and log in. Check your inbox for the verification link.",
  error: "Ooops!",
  somethingWrong: "Something went wrong!",
  selectDates: "Select dates",
  apply: "Apply",
  skipNovice: "Skip Novice",
  // Dog History

  noTrialsEntered: "No of Trials Entered",
  noQualifications: "No of Qs Earned",
  noTitles: "No of Titles",
  titlesEarned: "Titles Earned",
  titles: "Titles",
  date: "Date",
  downloadCertificate: "Download Certificate",
  previous: "Previous",
  scentIndicationTest: "Scent Indication Test",
  premiumPointsSummary: "Premier Points Summary",
  location: "Location",
  trialLocation: "Trial Location",
  pointsEarned: "Points Earned",
  totalPoints: "Total Points",
  summaryStandard: "Q Summary: Standard",
  summaryPro: "Q Summary: Pro",
  premierResults: "Premier Results",
  noviceAdvancedResults: "SIT, Novice, Advanced & Excellent Results",
  class: "Element",
  handler: "Handler",
  div: "Div",
  faultsOf: "# of Faults",
  faults: "Faults",
  time: "Time",
  hidesFound: "Hides Found",
  points: "Points",
  place: "Place",
  timeLimit: "Time Limit",
  hideSet: "Hide Set",
  judgeNotes: "Judge Notes",
  judgeDetails: "Judge Details",
  searchName: "Search Name",
  hide1: "Hide 1",
  hide2: "Hide 2",
  hide3: "Hide 3",
  hide4: "Hide 4",
  hide5: "Hide 5",
  hide6: "Hide 6",
  hide7: "Hide 7",
  trialDetail: " Trial Details",
  trialCalender: "Trial Calender",
  upcomingTrial: " Upcoming Trials",
  level: "Levels",
  host: "Host",
  hostATrail: "Host A Trial",
  viewResults: "View Results",
  element: "Element",
  callName: "Dog Name",
  qNQ: "Q/NQ",
  viewMore: "View More",
  dog: "Dog",
  qNq: "Q/NQ",
  nqReason: "NQ Reason",
  faultReason: "Fault Reason",
  editNAEResults: "Edit NAE Results",

  // Host Side Nav
  addTrial: "Add Trial",
  viewMembers: "View Members",
  viewDogs: "View Dogs",
  viewJudges: "View Judges",
  viewHosts: "View Hosts",
  dashboard: "Dashboard",
  trialDraw: "Trial Draw",
  competitorList: "Competitor List",
  trialStatistics: "Trial Statistics",
  uploadTrialResults: "Upload Trial Results",
  uploadTrialResultsSubTxt:
    "Results will be published trial results and dog history",
  editSit: "Edit SITs",
  sit: "SIT",
  openDate: "Open Date",
  city: "City",
  state: "State",
  zipCode: "Zip Code",
  closeDate: "Close Date",
  cutoffDate: "Cutoff Date",
  viewEntries: "View Entries",
  downloadEntires: "Download Entries",
  trialPremium: "Download Trial Premium",
  viewFullDetails: "View Full Details",
  editTrial: "Edit Trial",

  // Add Trial
  pendingPayment: "Pending Payment",
  paymentIsPending: "Payment for the dogs is pending.",
  hostDetails: "Host Details",
  trialDetails: "Trial Details",
  searchDetails: "Search Details",
  hostName: "Host Name",
  contactAddress: "Contact Address",
  hostPaypalEmail: "Host Paypal Email",
  trialSecretaryName: "Trial Administrator Name",
  trialSecretaryEmailAddress: "Trial Administrator Email Address",
  zip: "Zip",
  description: "Description",
  notes: "Notes",
  notesSubText:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  notesShowHere: "Notes will show here",
  hostNameRequired: "Host name is required",
  contactAddressRequired: "Contact address is required",
  hostPaypalEmailRequired: "Host paypal email is required",
  trialSecretaryNameRequired: "Trial administrator name is required",
  trialSecretaryEmailAddressRequired:
    "Trial administrator email address is required",
  zipRequired: "Zip is required",
  descRequired: "Description is required",
  notesRequired: "Notes is required",
  trialName: "Trial Name",
  trialNameRequired: "Trial Name is required",
  trialLocationName: "Trial Location Name",
  timeZoneRequired: "Time Zone is required",
  timeZone: "Time Zone",
  trialLocationAddress: "Trial Location Address",
  trialDate: "Trial Date",
  trialLocationNameRequired: "Trial location name is required",
  trialLocationAddressRequired: "Trial location address is required",
  searchDetail: "Search Detail",
  novice: "Novice",
  selectLevel: "Select Level",
  containers: "Containers",
  entryFee: "Entry Fee",
  maxNumberEntries: "Max Number of Entries",
  addSearchDetail: "Add search detail",
  addAnotherSearch: "Add Another Search",
  entryFeeRequired: "Please enter a fee",
  searchNameRequired: "Search name is required",
  containerNameRequired: "Container name is required",
  levelNameIsRequired: "Level name is required",
  maxNumberEntriesRequired: "Max number of entries must be positive",
  remove: "Remove",
  trialSubmittedSuccessfully: "Trial Submitted Successfully!",
  trialUpdatedSuccessfully: "Trial Updated Successfully!",
  addPaymentDetails: "Add Payment Details ",
  paymentMethod: "Payment Method",
  card: "Card",
  payPal: "PayPal",
  paymentSummary: "Payment Summary",
  registrationFees: "Registration Fees",
  totalPrice: "Total Price",
  pay: "Pay",
  paymentFailed: "Payment Failed",
  paymentSuccessTitle: "Payment Successfull",
  paymentSuccess:
    "Registration process completed. Your dog(s) can now participate in KSG trials!",
  Novice: "Novice",
  advanced: "Advanced",
  excellent: "Excellent",
  premier: "Premier",
  provisional: "Provisional",
  trialPremier: "Trial Results - Premier",
  dogResultsPremier:"Dog Results - Premier",
  dogResults:"Dog Results - NA&E",
  getPotentialTitles: "Get Potential Titles",
  allCompetitorsReport: "All Competitors",
  csvOrPdf: "CSV or PDF (Max file size: 2 MB)",
  inputNotMeet: "Input does not meet acceptance criteria.",
  selectFromOption: "Please select an option from suggestion",
  birchSIT: "Birch SIT",
  aniseSIT: "Anise SIT",
  cloveSIT: "Clove SIT",
  noviceContainers: "Novice Containers",
  noviceExteriors: "Novice Exteriors",
  noviceFastFinds: "Novice FastFinds",
  noviceInteriors: "Novice Interiors",
  noviceSolo: "Novice Solo",
  advancedContainers: "Advanced Containers",
  advancedExteriors: "Advanced Exteriors",
  advancedFastFinds: "Advanced FastFinds",
  advancedInteriors: "Advanced Interiors",
  advancedSolo: "Advanced Solo",
  excellentContainers: "Excellent Containers",
  excellentExteriors: "Excellent Exteriors",
  excellentFastFinds: "Excellent FastFinds",
  excellentInteriors: "Excellent Interiors",
  excellentSolo: "Excellent Solo",
  premierFullTrial: "Premier Full Trial",
  premierShortTrial: "Premier Short Trial",
  searchContainers: "Search Containers",
  selectSearch: "Select Search",
  pngOrJpg: "PNG or JPG (Max file size: 5 MB)",
  tooltipMsg: "Please fill out one form for each trial day.",
  numberOfJudges: "Number of Judges",
  addJudgesNames: "Add Judges' Names",
  uploadImages: "Upload Image",
  numberOfJudgesRequired: "Please enter the Judges' Names",

  // DocSignup
  dogSignup: "Sign Up",
  dogSignupTitle: "Fill in the details below",
  dogDropdown: "Select Dog",
  dogDropdownRequired: "Select a Dog",
  division: "Division",
  divisionRequired: "Select a Division",
  elements: "Elements",
  elementsRequired: "Select a Elements",
  dogsSignupSuccess: "Dog signup successfully",
  dogsSignupSuccessDescription: "Dog signup data stored successfully",

  // My Profile
  myProfile: "My Profile",
  userRolePlaceHolder: "Select role",
  profileRoleSuccess: "Member role updated",
  proleRoleSuccessDescription: "Member role successfully updated",
  profileUpdated: "Profile updated",
  profileUpdatedSuccessDesc: "Profile successfully updated.",
  edit: "Edit",
  delete: "Delete",
  firstName: "First name",
  lastName: "Last name",
  emailAddress: "Email address",
  address: "Address",
  phoneNumber: "Phone Number",
  emergencyContactName: "Emergency contact name",
  emergencyPhoneNumber: "Emergency phone number",
  emergencyContactNameCap: "Emergency Contact Name",
  emergencyContactNumberCap: "Emergency Contact Number",
  // My Profile
  pleaseSelectCity: "Please select city",
  pleaseSelectState: "Please select state",

  // Upload Trials Resules
  trialResultDate: "Date",
  trialResultLocation: "Location",
  trialResultLevel: "Level",
  trialResultHost: "Host",
  trialResultOpenDate: "Open Date",
  trialResultCloseDate: "Close Date",
  trialResultCutoffDate: "Cutoff Date",
  trialResultViewResult: "View Results",
  selectTrialsPlaceholder: "Select Trial",
  noOfEntries: "No of Entries",
  finalEntryTelly: "Final Entry Tally",
  memberName: "Member Name",
  dogId: "Dog Id",
  dogName: "Dog Name",
  ownerName: "Owner Name",
  birch: "Birch",
  anise: "Anise",
  clove: "Clove",
  selectDog: "Select Dog",
  viewDogHistory: "View Dog History",

  // View Judges
  allJudges: "All Judges",
  judgeName: "Judge Name",
  distanceReadyToTravel: "Distance Willing to Travel",
  numberOfRailJudge: "No of Trails Judged",

  //Trial Draw
  trailDraw: "Trial Draw",
  acceptedEntries: "Accepted Entries",
  notifyViaEmail: "Notify via Email",
  cancelDraw: "Cancel Draw",
  viewDrawEntries: "View Draw Entries",
  chooseEntries: "Choose Entries",
  addFromWaitlist: "Add from Waitlist",
  addAdditionalEntries: "Add Additional Entries",
  TrailDrawSearchLabel: "Select a trial to draw entries randomly",
  TrailDrawSearchPlaceHolder: "13 Sept, Finmere Village, Novice",

  //Super Admin Variables
  adminDashboard: "Dashboard",
  manageDogs: "Manage Dogs",
  manageUsers: "Manage Members",
  detailsOdUsers: "Details of Members",
  payments: "Payments",
  paymentStatus: "Payment Status",
  manageGallery: "Manage Gallery",
  trailManagement: "Trial Management",
  manageTrail: "Manage Trial",
  analytics: "Analytics",
  mostTitleEarnedbyState: "Most Titles Earned by State",
  mostTitleEarnedbyBreed: "Most Titles Earned by Breed",
  noOfDogsEarned: "No of Dogs Earned Title",
  noOfTrialEntered: "No of Trials Entered",
  noOfQualification: "No of Qs",
  noOfNonQualification: "No of NQs",
  noOfDogs: "No. Of Dogs Earned Title",
  dogsName: "Dog Name (s)",
  dateOfJoining: "Date of Joining",
  amount: "Amount",
  detailOfImages: "Details of Images",
  numberLabel: "No.",
  imageName: "Image Name",
  upload: "Upload",
  uploadImage: "Upload New Image",
  markAsPaid: "Mark as Paid",
  markedAsPaid: "Marked As Paid",
  detailOfMembers: "Details of Members",
  paid: "Paid",
  ageRange: "Age Range",
  yearsOld: "5 to 10 years old",
  areYouSureCancelDraw: "Are you sure you want to cancel the draw?",
  emailSent: "Email Sent Successfully",
  membersNotifiedAboutSelection:
    "Members have been notified about their selection into the trial.",
  //Super Admin Variables
  generateReport: "Generate Reports",
  listOfTrial: "List of Trial",
  // SuperAdmin

  detailsDogs: "Details of Dogs",
  titleDate: "Title Date",
  title: "Title",
  shortTitle: "Short Title",
  qs: "Qs",
  trailStatus: "Trial Status",
  approvalStatus: "Approval Status",
  dogLegs: "Dog legs",
  active: "Active",
  retired: "Retired",
  deceased: "Deceased",
  editProfile: "Edit Profile",
  addDogHistory: "Add Dog History",
  editDogHistory: "Edit Dog History",
  deleteProfile: "Delete Profile",
  uploadDogHistory: "Upload Dog History",
  dogHistoryPublishedProfile:
    "Dog history will be published in each dog’s profile.",
  uploadHistory: "Upload History",
  note: "Note",
  addNote: "Add Note",
  updateNote: "Update Note",
  addNoteHere: "Add note here",
  noteError: "Error: Note not displayed.",
  submit: "Submit",
  titleAnalytics: "Title Analytics",
  trialAnalytics: "Trial Analytics",
  success: "Success!",
  numberOfTrailParticipated: "No of Trials Participated",
  numberOfTrailJudge: "No of Trials Judged",
  dogEnteredInTrail: "Dog Entered in Trial",
  dogEntries: "Dog Entries",
  editUserProfile: "Edit Member Profile",

  // EditDogProfile

  editDogProfile: "Edit Dog Profile",
  dogNameError: "Error: Dog Name not displayed.",
  breedError: "Error: Breed not displayed.",
  breedMixError: "Error: Mix-Breed not displayed.",
  ownerNameError: "Error: Owner Name not displayed.",
  titleDateErrr: "Error: Title Date not displayed.",
  titleError: "Title not displayed.",
  qsError: "Error: Qs not displayed.",
  dogLegsError: "Error: Dog legs not displayed.",
  statusError: "Error: Status not displayed.",
  owner: "Owner",
  action: "Action",
  addEntries: "Add Entries",
  cancelChanges: "Cancel Changes",
  saveChanges: "Save Changes",
  role: "Role",
  trails: "Trails",
  trials: "Trials",
  numberOfTrailHosted: "No of Trials Hosted",
  numberOfUpComingTask: "No of Upcoming Trials",
  downloadAnalytics: "Download Analytics",
  download: "Download",
  noDataAvailable: "No Data Available!",

  // Host Profile

  emailId: "Email",
  website: "Website",
  addDataToSave: "Please add some data to save",
  listOfUser: "List of Users",
  numberOfEntries: "Number of Entries",

  // Judge
  selectTimeZone: "Please select your Time zone.",
  enterValidDistance: "Please enter a valid distance.",
  enterValidAddress: "Please enter a valid address.",
  enterYourPhoneNumber: "Enter your phone number",
  basicDetails: "Basic Details",
  pleaseFillDetailsJudge: "Please fill these details to sign up as a Judge",
  distanceReadyTravel: "Distance willing to travel",
  enterDistanceReady: "Enter distance willing to travel (KM)",
  enterYourAddress: "Enter your address",
  continue: "Continue",
  judgeApplicationSubmitted: "Judge Application Submitted Successfully!",
  judgeApplication: "Judge's Application",
  approveJudge: "Approve Judge",
  approveJudgeDesc: "You can approve the judge according to levels.",
  noviceLevel: "Novice Level",
  intermediateLevel: "Intermediate Level",
  masterLevel: "Master Level",
  expertLevel: "Expert Level",
  enterNameProceed: "Please enter your name to proceed.",
  typeYourDistance: "Type your distance",
  myJudgeProfile: "My Judge’s Profile",

  //Trial Status
  approve: "Approve",
  reject: "Reject",
  pending: "Pending",
  logout: "Log out",
  noRecord: "No Record",
  close: "Close",
  upcoming: "Upcoming",
  open: "Open",

  // Certificate

  certificateTitle: "CERTIFICATE OF TITLE",
  awardedTo: "Awarded to",
  forHavingCompletedRequirements: "For having completed the requirements for",
  on: "on",

  // Reports
  passRate: "Pass Rate",
  titleAndAwards: "Titles & Awards",
  trialDrawEntiries: "Trial Draw Enteries",

  //Trial Draw
  entries: "Entries",
  enteredIn: "Entered in:",
  waitList: "Waitlist",
  scoreCatalog: "Score Catalog",
  stickers: "Stickers",
  sureDeleteTrial: "Are you sure you want to delete trial?",
  deleteTrial: "Delete Trial",

  //Become a judge
  fillFromToBecomeJudge:
    "Fill in the details below and apply to become a Judge",
  approveORRejectJudges: "Approve/Reject Judges",
  approvedJudges: "Approved Judges",
};
